import { render, staticRenderFns } from "./SocialDataNativePage.vue?vue&type=template&id=3d3b2c02&scoped=true&"
import script from "./SocialDataNativePage.vue?vue&type=script&lang=js&"
export * from "./SocialDataNativePage.vue?vue&type=script&lang=js&"
import style0 from "./SocialDataNativePage.vue?vue&type=style&index=0&id=3d3b2c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3b2c02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
